@if (vm$ | async; as vm) {
  @if (vm.isAdmin) {
    <div class="admin-debug" [class.admin-debug--open]="expanded">
      <button type="button"
        mat-stroked-button
        class="admin-debug__toggle"
        (click)="toggle()"
        color="accent">
        {{ expanded ? 'Hide Admin' : 'Admin' }}
      </button>
      @if (expanded) {
        <div class="admin-debug__sheet">
          <section class="admin-debug__section">
            <h3 class="admin-debug__heading">User</h3>
            <dl class="admin-debug__dl">
              <dt>Name</dt>
              <dd>{{ vm.firstName }} {{ vm.lastName }}</dd>
              <dt>User name</dt>
              <dd>{{ vm.userName || '—' }}</dd>
              <dt>Email</dt>
              <dd>{{ vm.email || '—' }}</dd>
              <dt>GUID</dt>
              <dd class="admin-debug__mono">{{ vm.guid || '—' }}</dd>
              <dt>Admin full</dt>
              <dd>{{ vm.adminFull }}</dd>
              <dt>Admin view</dt>
              <dd>{{ vm.adminView }}</dd>
            </dl>
          </section>
          <section class="admin-debug__section">
            <h3 class="admin-debug__heading">Selected location</h3>
            @if (vm.location; as loc) {
              <dl class="admin-debug__dl">
                <dt>Name</dt>
                <dd>{{ loc.locationName }}</dd>
                <dt>Location number</dt>
                <dd class="admin-debug__mono">{{ loc.locationNumber }}</dd>
                <dt>Time zone</dt>
                <dd>{{ loc.timeZone || loc.locationTimeZone || '—' }}</dd>
                <dt>Default</dt>
                <dd>{{ loc.isDefaultLocation }}</dd>
              </dl>
              @if (loc.address) {
                <pre class="admin-debug__json">{{ loc.address | json }}</pre>
              }
            } @else {
              <p class="admin-debug__muted">No location selected.</p>
            }
          </section>
          @if (canSimulate(vm.isAdmin)) {
            <section class="admin-debug__section" data-testid="location-simulator">
              <h3 class="admin-debug__heading">Simulate unavailable locations</h3>
              @if (simulatingLabel; as label) {
                <p class="admin-debug__actions-note" data-testid="simulating-note">Simulating: {{ label }}</p>
              }
              <div class="admin-debug__actions">
                @for (scenario of scenarios; track scenario.id) {
                  <button type="button"
                    mat-stroked-button
                    color="accent"
                    [attr.data-testid]="'simulate-' + scenario.id"
                    (click)="simulate(scenario.id)">
                    {{ scenario.label }}
                  </button>
                }
                <button type="button"
                  mat-stroked-button
                  data-testid="simulate-off"
                  (click)="turnOffSimulation()">
                  Off
                </button>
              </div>
              <p class="admin-debug__actions-note">
                Client-side only; choosing a scenario reloads the page, Off returns to the homepage. To simulate a requested location, turn on
                "Favorite location unavailable" and open /&lt;that number&gt; directly.
              </p>
            </section>
          }
          <section class="admin-debug__section">
            <h3 class="admin-debug__heading">Actions</h3>
            <div class="admin-debug__actions">
              <button type="button"
                mat-stroked-button
                color="accent"
                (click)="copyAccessToken()">
                Copy access token
              </button>
            </div>
            <p class="admin-debug__actions-note">
              Copies the current Okta JWT used for API calls. Handle as a secret.
            </p>
          </section>
        </div>
      }
    </div>
  }
}
